import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["CurrentTransformer"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getCurrentTransformer: build.query<
        GetCurrentTransformerApiResponse,
        GetCurrentTransformerApiArg
      >({
        query: () => ({ url: `/CurrentTransformer` }),
        providesTags: ["CurrentTransformer"],
      }),
      putCurrentTransformerByName: build.mutation<
        PutCurrentTransformerByNameApiResponse,
        PutCurrentTransformerByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/CurrentTransformer/${queryArg.name}`,
          method: "PUT",
          body: queryArg.currentTransformerDto,
        }),
        invalidatesTags: ["CurrentTransformer"],
      }),
      deleteCurrentTransformerByName: build.mutation<
        DeleteCurrentTransformerByNameApiResponse,
        DeleteCurrentTransformerByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/CurrentTransformer/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["CurrentTransformer"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as currentTransformerApi };
export type GetCurrentTransformerApiResponse =
  /** status 200 OK */ CurrentTransformerDto[];
export type GetCurrentTransformerApiArg = void;
export type PutCurrentTransformerByNameApiResponse = /** status 200 OK */ void;
export type PutCurrentTransformerByNameApiArg = {
  name: string;
  currentTransformerDto: CurrentTransformerDto;
};
export type DeleteCurrentTransformerByNameApiResponse = unknown;
export type DeleteCurrentTransformerByNameApiArg = string;
export type CurrentTransformerDto = {
  name: string;
  comment?: string | null;
  isUsed: boolean;
  transformationFactor?: number | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetCurrentTransformerQuery,
  useLazyGetCurrentTransformerQuery,
  usePutCurrentTransformerByNameMutation,
  useDeleteCurrentTransformerByNameMutation,
} = injectedRtkApi;
